import {
  GET_EXPERIMENT,
  GET_EXPERIMENT_DATA,
  SET_TIME_RANGE
} from '../../actions/experiments'

import { getUtcTimestamp } from '../../utils/utilityFuncs'

const TIME_RANGE_STEPS = 500

const initialState = {
  isFetched: false,
  timeRange: null
}

function buildTimeRangeTimestamps (start, end) {
  const utcStart = getUtcTimestamp(start)
  const utcEnd = getUtcTimestamp(end ?? new Date())
  const timestamps = []

  for (let i = 0; i <= TIME_RANGE_STEPS; i++) {
    const current = i === TIME_RANGE_STEPS ? utcEnd : utcStart + (utcEnd - utcStart) * i / TIME_RANGE_STEPS
    timestamps.push(new Date(current).toUTCString())
  }
  return timestamps
}

function extractLatestSensorAndImage (data) {
  let sensor, image, timeStamp
  for (let i = data.length - 1; i >= 0; i--) {
    const { type, data: itemData, time } = data[i]
    if (type === 'sensor') {
      timeStamp = time
      sensor = itemData
    } else {
      timeStamp = time
      image = itemData
    }
    if (sensor != null && image != null) break
  }
  return { sensor, image, timeStamp }
}

export const experimentReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case 'CLEAR_EXPERIMENT':
      return initialState

    case GET_EXPERIMENT:
      return {
        ...state,
        isFetched: true,
        ...payload.experiment
      }

    case SET_TIME_RANGE: {
      const { start, end } = payload
      return {
        ...state,
        timeRange: buildTimeRangeTimestamps(start, end)
      }
    }

    case GET_EXPERIMENT_DATA: {
      const isNoData =
        payload === 'No data received' ||
        (payload?.data != null && payload.data.length < 1)

      if (isNoData) {
        return {
          ...state,
          isFetched: true,
          ...(payload?.experiment != null && { experiment: payload.experiment }),
          data: null
        }
      }

      const { device } = payload.data[0]
      const { sensor, image, timeStamp } = extractLatestSensorAndImage(payload.data)

      return {
        ...state,
        device,
        data: {
          sensor,
          image,
          time: timeStamp
        }
      }
    }

    default:
      return state
  }
}

export default experimentReducer
